import React from 'react';
import printJS from 'print-js';
import apiService from 'apiService';

const PrintButton = ({ url, buttonText = 'print', color = 'primary' }) => {
  const requestFile = async (url) => {
    const res = await apiService.getblob(url);
    if (res) {
      const file = new Blob([res], { type: 'application/pdf' });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //print blob
      printJS(fileURL);
    }
  };

  return <button className={'btn btn-' + color + ' btn-sm mt-1 float-right'} onClick={() => requestFile(url)}>{buttonText}</button>;
};

export default PrintButton;
